import { __assign, __makeTemplateObject, __rest } from "tslib";
import React, { forwardRef, useMemo } from 'react';
import clsx from 'clsx';
import { styled, useDeprecatedCheck, useThemeProps, } from '../../foundation';
import { RcPresence } from '../Presence';
import { RcTooltip, withTooltip } from '../Tooltip';
import { RcAvatarMask, StyledAvatar, StyledAvatarWrapper, StyledIconAvatar, StyledPresenceWrapper, } from './styles';
import { RcAvatarClasses, RcAvatarSizes } from './utils';
var _RcAvatar = forwardRef(function (inProps, ref) {
    // change default unClickable to here, prevent warning
    var props = useThemeProps({ props: inProps, name: 'RcAvatar' });
    if (process.env.NODE_ENV !== 'production') {
        // eslint-disable-next-line react-hooks/rules-of-hooks
        useDeprecatedCheck(RcAvatar, inProps, [
            {
                prop: 'customColor',
                time: '2021-3',
                comment: "if 'true', will just use color value, use `color` directly ",
            },
            {
                prop: 'unClickable',
                time: '2021-3',
                comment: "force set avatar clickable, default is true, please use clickable to set clickable ",
            },
            {
                prop: 'isMember',
                time: '2021-3',
                comment: "not used, just keep type temp ",
            },
            {
                prop: 'displayName',
                time: '2021-3',
                comment: "not used, just keep type temp ",
            },
            {
                prop: 'alt',
                time: '2021-3',
                comment: "alt for img, just use `<img src /> in children or imgProps for apply alt` ",
            },
            {
                prop: 'tooltip',
                time: '2021-3',
                comment: "support tooltip for avatar, use title to replace ",
            },
        ]);
    }
    var presenceOrigin = props.presenceOrigin, idProps = props.id, size = props.size, classes = props.classes, color = props.color, children = props.children, _clickable = props.clickable, onClick = props.onClick, mask = props.mask, presence = props.presence, customColor = props.customColor, tooltip = props.tooltip, iconSize = props.iconSize, iconSymbol = props.iconSymbol, srcProp = props.src, altProp = props.alt, Img = props.Img, imgProps = props.imgProps, presenceProps = props.presenceProps, displayName = props.displayName, rest = __rest(props, ["presenceOrigin", "id", "size", "classes", "color", "children", "clickable", "onClick", "mask", "presence", "customColor", "tooltip", "iconSize", "iconSymbol", "src", "alt", "Img", "imgProps", "presenceProps", "displayName"]);
    var unClickable = props.unClickable;
    unClickable = unClickable !== null && unClickable !== void 0 ? unClickable : true;
    // TODO: only when use not set clickable, use the unClickable as click props,
    // TODO: let should remove when app replace all of that
    var clickable = _clickable !== null && _clickable !== void 0 ? _clickable : !unClickable;
    var handleClick = useMemo(function () {
        var haveClick = clickable || (!unClickable && onClick);
        return haveClick ? onClick : undefined;
    }, [clickable, onClick, unClickable]);
    var avatar = useMemo(function () {
        var avatarChildren = (function () {
            var src = srcProp || (imgProps === null || imgProps === void 0 ? void 0 : imgProps.src);
            if (src) {
                var ImgComp = Img || 'img';
                return React.createElement(ImgComp, __assign({ src: src, alt: altProp }, imgProps));
            }
            if (iconSymbol) {
                var _size = iconSize === 'half'
                    ? RcAvatarSizes[size] / 2
                    : RcAvatarSizes[iconSize || size];
                return React.createElement(StyledIconAvatar, { size: _size, symbol: iconSymbol });
            }
            return children || null;
        })();
        var _avatar = (React.createElement(StyledAvatar, { size: size, color: color, iconSymbol: iconSymbol, className: clsx(classes === null || classes === void 0 ? void 0 : classes.avatarContainer, RcAvatarClasses.avatarContainer) },
            avatarChildren,
            mask && (React.createElement(RcAvatarMask, { className: clsx(classes === null || classes === void 0 ? void 0 : classes.mask, RcAvatarClasses.mask) }, typeof mask === 'boolean' ? undefined : mask))));
        // TODO: this tooltip will be remove in Juno
        if (tooltip) {
            _avatar = React.createElement(RcTooltip, { title: tooltip }, _avatar);
        }
        return _avatar;
    }, [
        Img,
        altProp,
        children,
        classes === null || classes === void 0 ? void 0 : classes.avatarContainer,
        classes === null || classes === void 0 ? void 0 : classes.mask,
        color,
        iconSize,
        iconSymbol,
        imgProps,
        mask,
        size,
        srcProp,
        tooltip,
    ]);
    var _a = presenceOrigin, horizontal = _a.horizontal, vertical = _a.vertical;
    var presenceChildren = useMemo(function () {
        var _presence = null;
        if (presence) {
            _presence = presence;
        }
        else if (presenceProps) {
            _presence = React.createElement(RcPresence, __assign({ size: size }, presenceProps));
        }
        if (_presence) {
            return (React.createElement(StyledPresenceWrapper, { horizontal: horizontal, vertical: vertical, className: clsx(classes === null || classes === void 0 ? void 0 : classes.presenceWrapper, RcAvatarClasses.presenceWrapper) }, _presence));
        }
        return null;
    }, [classes, horizontal, presence, presenceProps, size, vertical]);
    /**
     * @deprecated
     * TODO: should remove in Juno
     * */
    var dataAttrProps = idProps
        ? {
            id: "" + idProps,
            'data-uid': "" + idProps,
            'data-cid': "" + idProps,
            'data-test-automation-value': "" + idProps,
        }
        : {};
    return (React.createElement(StyledAvatarWrapper
    // as any for generic type
    , __assign({ 
        // as any for generic type
        ref: ref }, dataAttrProps, { onClick: handleClick, "data-test-automation-class": "avatar", 
        // as any for generic type
        clickable: clickable }, rest),
        avatar,
        presenceChildren));
});
var RcAvatar = styled(withTooltip(_RcAvatar))(templateObject_1 || (templateObject_1 = __makeTemplateObject([""], [""])));
RcAvatar.defaultProps = {
    size: 'medium',
    presenceOrigin: {
        horizontal: 'right',
        vertical: 'bottom',
    },
};
RcAvatar.displayName = 'RcAvatar';
var ExportType = RcAvatar;
export { ExportType as RcAvatar, StyledAvatar };
var templateObject_1;
